import { createConsumer } from "@rails/actioncable";

window.App ||= {};
window.App.cable = createConsumer();

import "./channels/partnership_contract_channel";
import "./channels/subscription_intention_channel";
